const Backbone = require('backbone');
var StockMessageView = Backbone.View.extend({
	initialize: function() {
		this.listenTo(Backbone, 'finish:clicked', this.render);
		this.listenTo(Backbone, 'finish:hover', this.render);
	},

	el: '.js-stock-message',

	render: function(data) {
		if (data.stockMessage) {
			this.$el.removeClass('text-green text-red text-black');
			if (data.isOutOfStock && !data.isMadeToOrder && !data.isPreOrder) {
				this.$el.addClass('text-red');
			}

			if (!data.isMadeToOrder && data.isPreOrder) {
				this.$el.addClass('text-black');
			}

			this.$el.html(data.stockMessage);
			this.$el.show();
		} else {
			this.$el.hide();
		}
	}
});

module.exports = StockMessageView;
